export default {
  BASE_URL: '/mm/unit',
  api: [
    {
      name: 'list',
      method: 'GET',
      desc: '获取计量单位列表',
      path: '/show/List',
      params: {
        pageSize: 25,
        pageNum: 1,
        brandName: '',
        category: '1;2'
      }
    },
    {
      name: 'changeState',
      method: 'POST',
      desc: '启用/禁用计量单位',
      path: 'operateStatus',
      params: {
        id: '',
        isEnable: false
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除计量单位',
      path: 'removeUnit',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '计量单位详情',
      path: 'currentUnit',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'checkName',
      method: 'GET',
      desc: '校验计量单位名称是否重复',
      path: '/validate/name',
      params: {
        id: '',
        unitName: ''
      }
    },
    {
      name: 'save',
      method: 'POST',
      desc: '保存计量单位',
      path: 'operate',
      params: {
        brandName: '',
        englishName: '',
        descript: '',
        sortNum: '',
        isEnable: '',
        origin: '',
        image: [],
        category: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/pm/units.js